module.exports = "<button><a href=\"/register\">Back</a></button>"